import ChannelMessageInput from './ChannelMessageInput';

export default ChannelMessageInput;
